export default [
  {
    path: '/subscriptions/search',
    name: 'subscriptionsSearch',
    meta: {
      title: '公众号搜索'
    },
    component(resolve) {
      require(['COMPONENTS/subscriptions/search/main.vue'], resolve)
    }
  },
  {
    path: '/subscriptions/add',
    name: 'subscriptionsAdd',
    meta: {
      title: '添加公众号'
    },
    component(resolve) {
      require(['COMPONENTS/subscriptions/add/main.vue'], resolve)
    }
  },
  {
    path: '/subscriptions/manage',
    name: 'subscriptionsManage',
    meta: {
      title: '公众号管理'
    },
    component(resolve) {
      require(['COMPONENTS/subscriptions/manage/main.vue'], resolve)
    }
  },
  {
    path: '/subscriptions/detail',
    name: 'subscriptionsDetail',
    meta: {
      title: '公众号详情'
    },
    component(resolve) {
      require(['COMPONENTS/subscriptions/detail/main.vue'], resolve)
    }
  },
]